import { jsx } from "react/jsx-runtime";
import { useRef, useEffect } from "react";
const ScrollLock = () => {
  const documentRef = useRef();
  useEffect(() => {
    const document = documentRef.current.ownerDocument;
    const { paddingRight, overflow } = document.body.style;
    document.body.style.paddingRight = `${document.defaultView.innerWidth - document.documentElement.clientWidth}px`;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = overflow;
      document.body.style.paddingRight = paddingRight;
    };
  }, []);
  return /* @__PURE__ */ jsx("span", { hidden: true, ref: documentRef });
};
export {
  ScrollLock
};
//# sourceMappingURL=ScrollLock.es.js.map
